export default "__VITE_ASSET__BJbNJc4G__"